/*
 * Public API Surface of angular-resize-event
 */

export { ResizedEvent } from './lib/resized.event';
export * from './lib/resized.directive';
export * from './lib/angular-resize-event.module';
